import { Reducer } from 'redux'
import { AppAction } from '../types'
import { ConfigurationState } from '../types/configurationTypes'
import fromEntries from 'object.fromentries'
import { convertInspirationToExpertConfiguration } from '../../model/ConstelaConfiguration'
import { ConstelaConfigurationModule } from '../../../types/ConstelaConfiguration'

const initialState: ConfigurationState = {
  inspirationMode: {},
  expertMode: {
    type: 'expert',
    lightingHead: { id: '' },
    modules: [],
    services: [],
    supportingColumn: { id: '' },
    properties: {}
  }
}

const configurationReducer: Reducer<ConfigurationState, AppAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'Data/Received': {
      const initialApplication =
        action.data.applications.find((x) => (x.id === location.hash ? location.hash.substring(1) : '')) ??
        action.data.applications[0]
      return {
        inspirationMode: fromEntries(
          action.data.applications.map((x) => [x.id, { ...x.defaultConfiguration, type: 'inspiration' }])
        ),
        expertMode: convertInspirationToExpertConfiguration(
          {
            ...(initialApplication?.defaultConfiguration ?? initialState.expertMode),
            type: 'inspiration'
          },
          action.data
        )
      }
    }
    case 'Configuration/SetModules': {
      if (action.mode === 'expert') {
        return {
          ...state,
          expertMode: {
            ...state.expertMode,
            modules: action.modules
          }
        }
      } else {
        return {
          ...state,
          inspirationMode: {
            ...state.inspirationMode,
            [action.applicationId]: {
              ...state.inspirationMode[action.applicationId],
              modules: action.modules
            }
          }
        }
      }
    }
    case 'Configuration/SetServices':
      return 'applicationId' in action
        ? {
            ...state,
            inspirationMode: {
              ...state.inspirationMode,
              [action.applicationId]: {
                ...state.inspirationMode[action.applicationId],
                services: action.services
              }
            }
          }
        : {
            ...state,
            expertMode: {
              ...state.expertMode,
              services: action.services
            }
          }
    case 'Configuration/SetProperties':
      return {
        ...state,
        expertMode: {
          ...state.expertMode,
          properties: action.module === 'global' ? action.properties ?? {} : state.expertMode.properties,
          modules:
            action.module === 'global'
              ? action.modules ?? state.expertMode.modules
              : state.expertMode.modules.map(
                  (module, i): ConstelaConfigurationModule =>
                    i === action.module ? { ...module, properties: action.properties } : module
                )
        }
      }
    case 'Configuration/TransferToExpertMode':
      return {
        ...state,
        expertMode: convertInspirationToExpertConfiguration(
          state.inspirationMode[action.applicationId] ?? state.expertMode,
          action.data
        )
      }
    default:
      return state
  }
}

export default configurationReducer
